export const TABLE_EMPLOYER_INDEX = {
  EmployerID: "memid",
  Status: "status",
  Name: "name",
  CoName: "coid",
  Position: "position",
  Contact: "contact",
  Email: "email",
  CreatedAt: "createdAt",
  UpdatedAt: "updatedAt",
  Remarks: "remark",
};

export const TABLE_EMPLOYER_TITLE = {
  EmployerID: "Employer ID",
  Status: "Status",
  Name: "Employer Name",
  CoName: "Company Name",
  CoID: "Company ID",
  Position: "Job Position",
  Contact: "Contact",
  Email: "Email",
  CreatedAt: "Created By",
  UpdatedAt: "Last Updated By",
  Remarks: "Remarks",
};

export const EMPLOYER_STATUS = {
  active: 1,
  suspended: 2,
  terminated: 0,
};

export const EMPLOYER_STATUS_TITLE = {
  [EMPLOYER_STATUS.active]: {
    name: "Active",
    colorTag: "#34C759",
    bgColor: "#DDFFE4",
    status: 1,
  },
  [EMPLOYER_STATUS.suspended]: {
    name: "Suspended",
    colorTag: "#FFA800",
    bgColor: "#FFF5E0",
    status: 2,
  },
  [EMPLOYER_STATUS.terminated]: {
    name: "Terminated",
    colorTag: "#FF0000",
    bgColor: "#FFF2F2",
    status: 0,
  },
};

export const EMPLOYER_INDEX = {
  name: "name",
  company: "coName",
  position: "position",
  contact: "contact",
  email: "email",
  createdBy: "createdBy",
  remark: "remark",
};

export const SELECT_OPTIONS = [
  { value: "createdAt", label: "Created Date", type: "date" },
  { value: "memid", label: "Employee ID", type: "text" },
  { value: "name", label: "Employer Name", type: "text" },
  { value: "email", label: "Employer Email", type: "text" },
  { value: "contact", label: "Employer Contact", type: "number" },
  { value: "coid", label: "Company ID", type: "text" },
  { value: "company_name", label: "Company Name", type: "text" },
];
